import { activity } from './activity';
import { enumItems } from './enumItems';
import { statuses } from './statuses';
import { group } from './group';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { SingleStripperReservation } from '../types/entities/SingleStripperReservation';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { TimeField } from '../components/Table/fields/TimeField';
import { SelectField } from '../components/Table/fields/SelectField';
import { Client } from '../services/Client';
import { address } from './address';
import { stripperProvider } from './stripperProvider';

export const singleStripperReservation: SchemaWithClient<SingleStripperReservation> = {
  name: 'Single Stripper Reservation',
  pluralName: 'Stripper Reservation',
  columns: {
    activity_reservation: {
      name: 'Activity Reservation',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityReservation),
      switchboard: true,
      required: true,
      readOnly: true,
      url: enumItems.activityReservation.client.getAllPath,
      tempSchema: enumItems.activityReservation,
    },
    group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(group),
      switchboard: true,
      tempSchema: group,
      readOnly: true,
    },
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activity),
      switchboard: true,
      tempSchema: activity,
      readOnly: true,
    },
    stripper: {
      name: 'Stripper',
      fieldRenderer: SelectField.tableAdapter(stripperProvider),
      switchboard: true,
      required: true,
      url: stripperProvider.client.getAllPath,
      tempSchema: stripperProvider,
    },
    status: {
      name: 'Status',
      fieldRenderer: SelectField.tableAdapter(
        statuses.stripperReservationStatus
      ),
      switchboard: true,
      url: statuses.stripperReservationStatus.client.getAllPath,
      tempSchema: statuses.stripperReservationStatus,
    },
    name: {
      name: 'Stripper Name',
      fieldRenderer: TextField,
      readOnly: true,
    },
    stripper_role: {
      name: 'Stripper Role',
      fieldRenderer: SelectField.tableAdapter(enumItems.stripperRole),
      switchboard: true,
      required: true,
      url: enumItems.stripperRole.client.getAllPath,
      tempSchema: enumItems.stripperRole,
    },
    meeting_time: {
      name: 'Meeting',
      fieldRenderer: TimeField,
      fieldType: 'time',
    },
    meeting_place: {
      name: 'Meeting Place',
      fieldRenderer: SelectField.tableAdapter(address),
      switchboard: true,
    },
    stripper_cost: {
      name: 'Cost',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    cost_currency: {
      name: 'Cost Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client(
    '/single-stripper-reservations',
    '/single-stripper-reservations'
  ),
};
